import React from 'react';
import styled from 'styled-components';
import { FaUsers, FaMoneyBill, FaTshirt, FaUserCheck, FaTasks } from 'react-icons/fa';
import BackHome from '../../imagens/backHome.png';

const Container = styled.div`
  color: #fff;
  background: url(${BackHome});
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: right;
  background-position-y: bottom;
  min-height: 100vh;
`;

const FutInfo = styled.div`
    text-align: center;
    padding: 24px 16px;
`;
const Title = styled.h1`
    font-size: 24px;
    font-weight: bold;
`;
const SubInfo = styled.p`
    margin-top: 4px;
    font-size: 16px;
`;
const QuickAccess = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
    margin-top: 2rem;
`;
const QuickButton = styled.button`
    padding: 14px;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    border: 1px solid rgba(206, 206, 206, 0.52);
    border-radius: 12px;
    color: white;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    width: fit-content;
    min-width: 250px;
    justify-content: center;

    &:hover {
        background: rgba(255, 255, 255, 0.2);
    }
`;

const HomeSection = () => {
  return (
    <Container>
      <FutInfo>
        <Title>Bem-vindo de volta!</Title>
        <SubInfo>Próximo jogo: Quarta às 21h</SubInfo>
        <SubInfo>Confirmados: 12 jogadores</SubInfo>
      </FutInfo>

      <QuickAccess>
        <a href='/confirm'>
          <QuickButton>
              <FaTasks /> Confirmar presença
          </QuickButton>
        </a>
        <a href='/generate-teams'>
          <QuickButton>
              <FaUsers /> Gerar Times
          </QuickButton>
        </a>
        <a href='members'>
          <QuickButton>
            <FaUserCheck /> Mensalistas
          </QuickButton>
        </a>
        <a href='finance'>
          <QuickButton>
              <FaMoneyBill /> Financeiro
          </QuickButton>
        </a>
        <a href='vests'>
          <QuickButton>
              <FaTshirt /> Coletes
          </QuickButton>
        </a>
      </QuickAccess>
    </Container>
  );
};

export default HomeSection;
